import Curtina1 from '../../../Media/KHI/Curtina.webp'
import Curtina2 from '../../../Media/KHI/Curtina.webp'


const Curtinaimages =[
Curtina1,Curtina2
]

export default Curtinaimages;